// 별별책방 - 본사 - 원별 사용량 - 상세 페이지
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import axios from "@app/lib/axios";

import ReactEcharts from "echarts-for-react";
import CommonVerticalBarChart from "@app/components/CommonVerticalBarChart";

import statStyle from "../components/style";

const baseClassesChartHeight = 300;
const minClassChartHeight = 50;
const NurserySub = forwardRef(({ statPeriod, branchName, nurseryId, nurseryName, selectedCategorySubOption }, ref) => {
    const [stat, setStat] = useState(false);
    const [statSum, setStatSum] = useState(false);
    const [statOs, setStatOs] = useState(false);
    const [statContent, setStatContent] = useState(false);
    const [statContentSum, setStatContentSum] = useState(false);
    const [barChartSize, setBarChartSize] = useState(false);
    const [showTab, setShowTab] = useState("play_count");

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const data = [];
            if (stat) {
                stat.forEach((s) => {
                    data.push([
                        s.className,
                        s[`k_v_play_count`],
                        s[`k_v_play_count_sum`],
                        s[`k_r_play_count`],
                        s[`k_r_play_count_sum`],
                        s[`k_s_play_count`],
                        s[`k_s_play_count_sum`],
                        s[`m_v_play_count`],
                        s[`m_v_play_count_sum`],
                        s[`m_r_play_count`],
                        s[`m_r_play_count_sum`],
                        s[`m_s_play_count`],
                        s[`m_s_play_count_sum`],
                        s[`total_play_count`],
                        s[`total_play_count_sum`],
                    ]);
                });
            }
            data.sort((a, b) => b.total_play_count_sum - a.total_play_count_sum);
            const excelData = {
                fileName: `모모한글수-원통계-${nurseryName}`,
                sheets: [
                    {
                        name: "접속",
                        title: `${nurseryName} - 접속 경로`,
                        columnTitle: ["APP", "WEB"],
                        data: statOs ? [statOs.map((s) => s.value)] : [],
                    },
                    {
                        name: "콘텐츠 사용량",
                        title: `${nurseryName} - 콘텐츠 사용 통계`,
                        columnTitle: {
                            rows: [
                                { title: ["한글", "한글", "한글", "한글", "한글", "한글", "수학", "수학", "수학", "수학", "수학", "수학", "합계(순)", "합계(누적)"], originColumn: 0 },
                                { title: ["영상", "영상", "리뷰", "리뷰", "스페셜", "스페셜", "영상", "영상", "리뷰", "리뷰", "스페셜", "스페셜"], originColumn: 0 },
                                { title: ["순", "누적", "순", "누적", "순", "누적", "순", "누적", "순", "누적", "순", "누적"], originColumn: 0 },
                            ],
                            merges: [
                                { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } }, // 한글
                                { s: { r: 0, c: 6 }, e: { r: 0, c: 11 } }, // 수학
                                { s: { r: 1, c: 0 }, e: { r: 1, c: 1 } }, // 한글-영상
                                { s: { r: 1, c: 2 }, e: { r: 1, c: 3 } }, // 한글-리뷰
                                { s: { r: 1, c: 4 }, e: { r: 1, c: 5 } }, // 한글-스페셜
                                { s: { r: 1, c: 6 }, e: { r: 1, c: 7 } }, // 수학-영상
                                { s: { r: 1, c: 8 }, e: { r: 1, c: 9 } }, // 수학-리뷰
                                { s: { r: 1, c: 10 }, e: { r: 1, c: 11 } }, // 수학-스페셜
                                { s: { r: 0, c: 12 }, e: { r: 2, c: 12 } }, // 합계(순)
                                { s: { r: 0, c: 13 }, e: { r: 2, c: 13 } }, // 합계(누적)
                            ],
                        },
                        data: statSum
                            ? [
                                  [
                                      statSum[`k_v_play_count`],
                                      statSum[`k_v_play_count_sum`],
                                      statSum[`k_r_play_count`],
                                      statSum[`k_r_play_count_sum`],
                                      statSum[`k_s_play_count`],
                                      statSum[`k_s_play_count_sum`],
                                      statSum[`m_v_play_count`],
                                      statSum[`m_v_play_count_sum`],
                                      statSum[`m_r_play_count`],
                                      statSum[`m_r_play_count_sum`],
                                      statSum[`m_s_play_count`],
                                      statSum[`m_s_play_count_sum`],
                                      statSum[`total_play_count`],
                                      statSum[`total_play_count_sum`],
                                  ],
                              ]
                            : [],
                    },
                    {
                        name: "반별 콘텐츠 실행 수",
                        title: `${nurseryName} - 반별 콘텐츠 사용 통계`,
                        columnTitle: {
                            rows: [
                                { title: ["반", "한글", "한글", "한글", "한글", "한글", "한글", "수학", "수학", "수학", "수학", "수학", "수학", "합계(순)", "합계(누적)"], originColumn: 0 },
                                { title: ["영상", "영상", "리뷰", "리뷰", "스페셜", "스페셜", "영상", "영상", "리뷰", "리뷰", "스페셜", "스페셜"], originColumn: 1 },
                                { title: ["순", "누적", "순", "누적", "순", "누적", "순", "누적", "순", "누적", "순", "누적"], originColumn: 1 },
                            ],
                            merges: [
                                { s: { r: 0, c: 0 }, e: { r: 2, c: 0 } }, // 반
                                { s: { r: 0, c: 1 }, e: { r: 0, c: 6 } }, // 한글
                                { s: { r: 0, c: 7 }, e: { r: 0, c: 12 } }, // 수학
                                { s: { r: 1, c: 1 }, e: { r: 1, c: 2 } }, // 한글-영상
                                { s: { r: 1, c: 3 }, e: { r: 1, c: 4 } }, // 한글-리뷰
                                { s: { r: 1, c: 5 }, e: { r: 1, c: 6 } }, // 한글-스페셜
                                { s: { r: 1, c: 7 }, e: { r: 1, c: 8 } }, // 수학-영상
                                { s: { r: 1, c: 9 }, e: { r: 1, c: 10 } }, // 수학-리뷰
                                { s: { r: 1, c: 11 }, e: { r: 1, c: 12 } }, // 수학-스페셜
                                { s: { r: 0, c: 13 }, e: { r: 2, c: 13 } }, // 합계(순)
                                { s: { r: 0, c: 14 }, e: { r: 2, c: 14 } }, // 합계(누적)
                            ],
                        },
                        data: data,
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const getStat = () => {
        axios({
            method: "POST",
            url: `/api/stat_momo/hq/nurseries/${nurseryId}`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                periodType: statPeriod.type,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    let classes = result.data.classes;
                    const stat = result.data.stats;
                    const statData = [];
                    const statSum = {
                        connectApp: 0,
                        connectWeb: 0,
                        k_v_play_count: 0,
                        k_v_play_count_sum: 0,
                        k_r_play_count: 0,
                        k_r_play_count_sum: 0,
                        k_s_play_count: 0,
                        k_s_play_count_sum: 0,
                        m_v_play_count: 0,
                        m_v_play_count_sum: 0,
                        m_r_play_count: 0,
                        m_r_play_count_sum: 0,
                        m_s_play_count: 0,
                        m_s_play_count_sum: 0,
                        total_play_count: 0,
                        total_play_count_sum: 0,
                    };
                    const statOs = [
                        { id: "connectApp", name: "APP", value: 0 },
                        { id: "connectWeb", name: "WEB", value: 0 },
                    ];

                    if (classes && classes.length > 0) {
                        classes = classes.sort((a, b) => {
                            if (a.className < b.className) {
                                return -1;
                            } else if (a.className > b.className) {
                                return 1;
                            } else {
                                return 0;
                            }
                        });
                        classes.forEach((c) => {
                            const s = stat.find((s) => c.classId == s.classId);
                            c.k_v_play_count = c.k_r_play_count = c.k_s_play_count = c.k_v_play_count_sum = c.k_r_play_count_sum = c.k_s_play_count_sum = 0;
                            c.m_v_play_count = c.m_r_play_count = c.m_s_play_count = c.m_v_play_count_sum = c.m_r_play_count_sum = c.m_s_play_count_sum = 0;
                            c.v_play_count = c.r_play_count = c.s_play_count = 0;
                            c.v_play_count_sum = c.r_play_count_sum = c.s_play_count_sum = 0;
                            c.total_play_count = c.total_play_count_sum = 0;
                            if (s) {
                                c = { ...c, ...s };
                                const keys = Object.keys(s);
                                keys.forEach((k) => {
                                    if (k != "classId") {
                                        statSum[k] += s[k] ? s[k] : 0;
                                        if (k.endsWith("_sum")) {
                                            c.total_play_count_sum += s[k] ? s[k] : 0;
                                            statSum.total_play_count_sum += s[k] ? s[k] : 0;
                                        } else if (k.endsWith("_play_count")) {
                                            c.total_play_count += s[k] ? s[k] : 0;
                                            statSum.total_play_count += s[k] ? s[k] : 0;
                                        }
                                    }
                                });
                            }
                            statData.push(c);
                        });
                    }

                    statOs[0].value = statSum.connectApp;
                    statOs[1].value = statSum.connectWeb;

                    setStat(statData);
                    setStatSum(statSum);
                    setStatOs(statOs);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };
    useEffect(() => {
        getStat();
        return () => {};
    }, [statPeriod]);

    useEffect(() => {
        const statContent = [
                { id: "v_play_count", name: "영상 순", value: 0 },
                { id: "r_play_count", name: "리뷰 순", value: 0 },
                { id: "s_r_play_count", name: "스페셜 순", value: 0 },
            ],
            statContentSum = [
                { id: "v_play_count_sum", name: "영상 누적", value: 0 },
                { id: "r_play_count_sum", name: "리뷰 누적", value: 0 },
                { id: "s_r_play_count_sum", name: "스페셜 누적", value: 0 },
            ];
        let barChartSize = baseClassesChartHeight;

        if (stat && stat.length > 0) {
            stat.forEach((s) => {
                s.v_play_count = s[`${selectedCategorySubOption}_v_play_count`];
                s.r_play_count = s[`${selectedCategorySubOption}_r_play_count`];
                s.s_play_count = s[`${selectedCategorySubOption}_s_play_count`];
                s.v_play_count_sum = s[`${selectedCategorySubOption}_v_play_count_sum`];
                s.r_play_count_sum = s[`${selectedCategorySubOption}_r_play_count_sum`];
                s.s_play_count_sum = s[`${selectedCategorySubOption}_s_play_count_sum`];
            });
            if(barChartSize < (stat.length * minClassChartHeight + 40)) {
                barChartSize = stat.length * minClassChartHeight + 40;
            }
        }

        if (statSum) {
            statContent[0].value = statSum[`${selectedCategorySubOption}_v_play_count`];
            statContent[1].value = statSum[`${selectedCategorySubOption}_r_play_count`];
            statContent[2].value = statSum[`${selectedCategorySubOption}_s_play_count`];

            statContentSum[0].value = statSum[`${selectedCategorySubOption}_v_play_count_sum`];
            statContentSum[1].value = statSum[`${selectedCategorySubOption}_r_play_count_sum`];
            statContentSum[2].value = statSum[`${selectedCategorySubOption}_s_play_count_sum`];
        }

        setStatContent(statContent);
        setStatContentSum(statContentSum);
        setBarChartSize(barChartSize);
    }, [statSum, selectedCategorySubOption]);

    const optionOs = {
        tooltip: {
            trigger: "item",
            formatter: (param) => {
                return param.data ? param.data.name + " : " + param.data.value.toLocaleString() + " (" + Math.ceil(param.percent) + "%)" : "";
            },
        },
        series: [
            {
                type: "pie",
                data: statOs,
                radius: "95%",
                startAngle: 45,
                center: ["40%", "50%"],
                color: statStyle.seriesConnectColor.normal,
                label: {
                    show: true,
                    formatter(param) {
                        return param.name + " - " + param.value.toLocaleString() + ", " + param.percent + "%";
                    },
                },
            },
        ],
        legend: {
            orient: "vertical",
            x: "right",
            y: "bottom",
        },
    };

    const optionContent = {
        tooltip: {
            trigger: "item",
            formatter: (param) => {
                return param.data ? param.data.name + " : " + param.data.value.toLocaleString() + " (" + Math.ceil(param.percent) + "%)" : "";
            },
        },
        series: [
            {
                type: "pie",
                data: statContent,
                radius: ["20%", "50%"],
                center: ["35%", "50%"],
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "center",
                },
                color: statStyle.seriesCategoryColor.pale,
            },
            {
                type: "pie",
                data: statContentSum,
                radius: ["60%", "95%"],
                center: ["35%", "50%"],
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "center",
                },
                color: statStyle.seriesCategoryColor.normal,
            },
        ],
        legend: {
            orient: "vertical",
            x: "right",
            y: "bottom",
            height: '70px',
        },
    };
    const chartOptionContent = {
        xAxis: {
            name: "건",
            series: statStyle.seriesContentChart,
        },
        yAxis: { field: "className" },
        stacks: [{ stack: "base", showSum: false, showSumTooltip: true, showPercent: true }],
        showLegend: true,
        legend: {
            x: "right",
            y: "top",
        },
        sort: false,
        grid: {
            top: "5%",
            left: "10%",
            right: "5%",
            bottom: "10%",
        },
    };
    const chartOptionContentSum = {
        xAxis: {
            name: "건",
            series: statStyle.seriesContentSumChart,
        },
        yAxis: { field: "className" },
        stacks: [{ stack: "base", showSum: false, showSumTooltip: true, showPercent: true }],
        showLegend: true,
        legend: {
            x: "right",
            y: "top",
        },
        sort: false,
        grid: {
            top: "5%",
            left: "10%",
            right: "5%",
            bottom: "10%",
        },
    };

    return (
        <div className="stat-branch-content">
            <div className="row mb-3">
                <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">접속 경로</h5>
                        </div>
                        <div className="card-body" style={{ height: "auto" }}>
                            <ReactEcharts theme="macarons" option={optionOs} style={{ height: `200px` }} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 사용 현황</h5>
                        </div>
                        <div className="card-body" style={{ height: "auto" }}>
                            <ReactEcharts theme="macarons" option={optionContent} style={{ height: `200px` }} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <a className="nav-link active" data-toggle="tab" href="#tabPlayCount" onClick={() => setShowTab("play_count")}>
                                    반 별 콘텐츠 순 실행 수
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-toggle="tab" href="#tabPlayCount" onClick={() => setShowTab("play_count_sum")}>
                                    반 별 콘텐츠 누적 실행 수
                                </a>
                            </li>
                        </ul>
                        <div className="tab-content">
                            <div className="tab-pane fade show active" id="tabPlayCount">
                                <div className="card-body" style={{ height: `${barChartSize}px` }}>
                                    <CommonVerticalBarChart chartData={stat} chartOption={showTab == "play_count" ? chartOptionContent : chartOptionContentSum} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default NurserySub;
